import { useState, useEffect } from "react";
import useFetch from "use-http";
import { useInterval } from "react-interval-hook";

export const DEFAULT_FIELDS =
  "created,external_fullname,external_name,external_image_cdn,comment,id,type";
export const DEFAULT_TYPES = "";
export const MIN_REFRESH_INTERVAL = 1000; // In seconds

let latestId = 0;

const WallsPosts = ({
  accessToken = null,
  refreshInterval = 10000,
  displayDuration = 4000,
  limit = 25,
  bufferSize = 20,
  fields = DEFAULT_FIELDS,
  types = DEFAULT_TYPES,
}) => {
  const [posts, setPosts] = useState([]);
  const [tick, setTick] = useState(1);

  const latestPostId = Math.max(...posts.map((p) => Number(p.id)));
  latestId = latestPostId || latestId;

  const {
    data = { data: [] },
  } = useFetch(
    `https://labs.walls.io/proxy/api/posts.json?access_token=${accessToken}&fields=${fields}&limit=${limit}&after=${latestId}&types=${types}`,
    { cachePolicy: "no-cache" },
    [tick]
  );

  const incTick = () => {
    setTick((i) => i + 1);
  };

  const setPost = () => {
    setPosts((posts) => {
      const first = posts.shift();
      return posts.concat([first]).slice(0, bufferSize);
    });
  };

  useEffect(() => {
    if (data?.data && data?.status === "success" && data?.data.length > 0) {
      const newPosts = data.data.sort((a, b) => b.id - a.id);

      setPosts((posts) => {
        posts.splice(posts.length > 0 ? 1 : 0, 0, ...newPosts);
        return posts.slice();
      });
    }
  }, [data]);

  useInterval(incTick, Math.max(MIN_REFRESH_INTERVAL, refreshInterval));
  useInterval(setPost, displayDuration);

  const post = posts[0];

  return {
    post,
  };
};

export default WallsPosts;
